import { createFileRoute } from '@tanstack/react-router'
import { ResellerPaymentsPage } from '@/features/reseller/pages/payments'

export const Route = createFileRoute('/_authenticated/reseller/payments')({
  component: ResellerPaymentsPage,
})
